import React from 'react';
import { Tree } from 'antd';

export default function KoTree({showLine, showLeafIcon, showIcon, onSelect, data}) {
  return (
    <Tree
      showLine={showLine ? { showLeafIcon } : false}
      showIcon={showIcon}
      defaultExpandedKeys={['0-0-0']}
      onSelect={onSelect}
      treeData={data}
    />
  );
}
